var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgBtnTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:none;}.a{stroke:#fff;}.b{fill:#fff;font-size:12px;font-family:NotoSans-Regular, Noto Sans;letter-spacing:0.02em;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1823 -978)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(1823 978)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 28.5,
    cy: 28.5,
    r: 28.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 28.5,
    cy: 28.5,
    r: 28
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1836.277,2152.863l7.06-7.06,7.06,7.06",
    transform: "translate(8.558 -1152.221)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "b",
    transform: "translate(1852 1018)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.772,
    y: 0
  }, "TOP")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnTop);
export default __webpack_public_path__ + "static/media/btn-top.1941e1b447293854e23cc5339e0507a6.svg";
export { ForwardRef as ReactComponent };